import React from "react";
import { useNavigate } from "react-router-dom";
import { SocketProvider } from "./socketContext";

const SocketProviderWithNavigation = ({ children }) => {
  const navigate = useNavigate();

  return <SocketProvider navigate={navigate}>{children}</SocketProvider>;
};

export default SocketProviderWithNavigation;
